import React, {useEffect, useState} from 'react';
import { Container, Row, Col } from "reactstrap";

const Footer = (props) => {
    const [version, setVersion] = useState('')
    
    useEffect(() => {
        const _version = localStorage.getItem('rotary_v')
        setVersion(_version)
    },[])

  return (
   <React.Fragment>
            <footer className="footer">
                <Container fluid={true}>
                    <Row>
                        {version && version != '' && (
                            <Col md={6}>
                                version:{version}
                            </Col>
                        )}
                        {/* <Col md={6}>
                            {new Date().getFullYear()} © Skote.
                        </Col>
                        <Col md={6}>
                            <div className="text-sm-right d-none d-sm-block">
                                Design & Develop by Themesbrand
                            </div>
                        </Col> */}
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
  );
}

export default Footer;